<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
          <strong> Allocate Load Management</strong> 
          </div>
          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
              <li class="nav-item">
                <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Not Assigned</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Assigned</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 6"  class="nav-link " :class="{'active' : isActiveTab(6)}">Dock/Zone In</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 7"  class="nav-link " :class="{'active' : isActiveTab(7)}">Dock/Zone Out</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 8"  class="nav-link " :class="{'active' : isActiveTab(8)}">Dispatch</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2"  class="nav-link" :class="{'active' : isActiveTab(2)}" >IN Transit</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 3"  class="nav-link" :class="{'active' : isActiveTab(3)}" >OFD</a>
              </li>

               <li class="nav-item">
                <a @click="activeTab = 4"  class="nav-link" :class="{'active' : isActiveTab(4)}" >Delivered</a>
              </li>
             
              <li class="nav-item">
                <a @click="activeTab = 5"  class="nav-link" :class="{'active' : isActiveTab(5)}" >NDR</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 9"  class="nav-link" :class="{'active' : isActiveTab(9)}" >NPR</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 10"  class="nav-link" :class="{'active' : isActiveTab(10)}" >Pick Done</a>
              </li>
             
            </ul>
          </div>
           
          </b-col>
          <b-col md="12" >
        
            <div class="tab-panel" v-if="isActiveTab(0)">
              <NotAssigned_mr style="width:70%;" :route_id="route_id"></NotAssigned_mr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(1)">
            <Assigned_mr style="width:70%;" :route_id="route_id"></Assigned_mr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <INTransit_mr style="width:70%;" :route_id="route_id"></INTransit_mr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(3)">
            <ofd_mr style="width:70%;" :route_id="route_id"></ofd_mr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(4)">
                <delivered_mr width=70% :route_id="route_id"></delivered_mr>
            </div>
          
            <div class="tab-panel" v-if="isActiveTab(5)">
            <ndr_mr width=70% :route_id="route_id"></ndr_mr>
            </div>

            <div class="tab-panel" v-if="isActiveTab(6)">
              <zonein_zoneout_dispatch_tab width=70% :route_id="route_id" type="ZoneInScan" key="ZoneInScan"></zonein_zoneout_dispatch_tab>
            </div>
            <div class="tab-panel" v-if="isActiveTab(7)">
              <zonein_zoneout_dispatch_tab width=70% :route_id="route_id" type="ZoneOutScan" key="ZoneOutScan"></zonein_zoneout_dispatch_tab>
            </div>
            <div class="tab-panel" v-if="isActiveTab(8)">
              <zonein_zoneout_dispatch_tab width=70% :route_id="route_id" type="DispatchOutScan" key="DispatchOutScan"></zonein_zoneout_dispatch_tab>
            </div>
            <div class="tab-panel" v-if="isActiveTab(9)">
              <NPR_mr width=70% :route_id="route_id" type="NPR" key="NPR"></NPR_mr>
            </div>
            <div class="tab-panel" v-if="isActiveTab(10)">
              <pickdone_mr width=70% :route_id="route_id" type="PickDone" key="PickDone"></pickdone_mr>
            </div>
            
          
             </b-col>
          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   
  
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import NotAssigned_mr from './notAssigned_mr.vue'
// import PickCancel_mr from './pickCancel_mr.vue'
import Assigned_mr from './assigned_mr.vue'
import INTransit_mr from './IN_transit_mr.vue'
import Ofd_mr from './ofd_mr.vue'
import delivered_mr from './delivered_mr.vue'
// import rto_mr from './rto_mr.vue'
import ndr_mr from './ndr_mr.vue'
import zonein_zoneout_dispatch_tab from './zonein_zoneout_dispatch_tab.vue'
import NPR_mr from './NPR_mr.vue'
import pickdone_mr from './pickdone_mr.vue'

export default {
  data: function() {
    return {
      activeTab: 0,
      NotAssigned_mr,
      // PickCancel_mr,
      Assigned_mr,
      INTransit_mr,
      Ofd_mr,
      id:'',
      delivered_mr,
      // rto_mr,
      ndr_mr,
      NPR_mr,
      pickdone_mr,
      route_id :null,
      name: 'exceptionReport_mr'
    };
  },
  components: {
    NotAssigned_mr,
    // PickCancel_mr,
    Assigned_mr,
    INTransit_mr,
    Ofd_mr,
    delivered_mr,
    // rto_mr,
    ndr_mr,
    zonein_zoneout_dispatch_tab,
    NPR_mr,
    pickdone_mr
  },
  created: function() {
    this.isActiveTab(0);
    this.route_id = this.$route.params.id;
    console.log("this.route_id",this.route_id)
  },
  beforeUpdate(){
    // console.log("beforeUpdateall----->",this.$route)
  },
  methods: {
  	isActiveTab(id)
    {
       return this.activeTab === id
    }
  }
};
</script>
